module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "blueprint"
  }, [_c('img', {
    ref: "planta",
    attrs: {
      "src": _vm.blueprint,
      "height": _vm.bpHeight,
      "width": _vm.bpWidth
    },
    on: {
      "load": _vm.calculate
    }
  }), _vm._v(" "), _vm._l((_vm.certificationProcess.areas), function(area, key) {
    return _c('div', {
      key: area['.key'],
      class: area.structures || area.status >= 1 ? "notdraggable" : "draggable",
      style: (("-webkit-transform:translate(" + ((_vm.clientWidth / _vm.certificationProcess.bpWidth) * area.x) + "px," + ((_vm.clientHeight / _vm.certificationProcess.bpHeight) * area.y) + "px);transform:translate(" + ((_vm.clientWidth / _vm.certificationProcess.bpWidth) * area.x) + "px," + ((_vm.clientHeight / _vm.certificationProcess.bpHeight)*area.y) + "px);width:" + ((_vm.clientWidth / _vm.certificationProcess.bpWidth) * parseInt(area.w,10)+"px") + "; height:" + ((_vm.clientHeight / _vm.certificationProcess.bpHeight) * parseInt(area.h,10)+"px"))),
      attrs: {
        "data-x": (_vm.clientWidth / _vm.certificationProcess.bpWidth) * area.x,
        "data-y": (_vm.clientHeight / _vm.certificationProcess.bpHeight) * area.y,
        "data-key": key
      }
    }, [_c('draggableArea', {
      attrs: {
        "number": key,
        "value": area
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "resize-edges": "bottom right"
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "resize-edges": "bottom left"
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "resize-edges": "top left"
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "resize-edges": "top right"
      }
    }), _vm._v(" "), (area.structures || area.status >= 1) ? _c('md-tooltip', {
      attrs: {
        "md-direction": "top"
      }
    }, [_vm._v("MOVIMENTAÇÃO BLOQUEADA!\n        ")]) : _vm._e(), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "bottom"
      }
    }, [_vm._v("CLIQUE 2X P/ ALTERAR OU EXCLUIR")])], 1)
  })], 2)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-fab-bottom-right",
    on: {
      "click": function($event) {
        return _vm.addArea()
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('add-area-dialog', {
    ref: "add_area_dialog",
    attrs: {
      "activeProcess": _vm.certificationProcess
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-229d15ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AreaView.vue
// module id = 826
// module chunks = 1